import api from './axios';
import type { ApiReportItem } from '../types/report.types';


export const reportService = {
  getReport: async (reportId: string, beginDate?: string, endDate?: string) => {
    console.log('Making API call with:', { reportId, beginDate, endDate });
    const response = await api.get<ApiReportItem[]>(`/reports/${reportId}/store-full-report`, {
      params: {
        begin: beginDate,
        end: endDate
      }
    });
    
    // const transformedData = transformReportData(response.data);
    return { data: response.data };
  }
}; 